
import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Input,
  Space,
  Card,
  Pagination
} from 'antd';
import strings from '../../utils/strings';
import moment from 'moment-jalaali';
import Highlighter from "react-highlight-words";
import { SearchOutlined, ZoomInOutlined } from "@ant-design/icons";
import InsuranceDetails from "../shared/insuranceDetails/InsuranceDetails";
import { usePersistedStore } from "../../store/persisted-store";
import { useGeneralStore } from "../../store/slices/createGeneralSlice";
import { useReportsStore } from "../../store/slices/createReportsSlice";

export default function UnderReviewTable() {
  const { getUnderReview, ...reports } = useReportsStore()
  const general = useGeneralStore();
  const { auth, business } = usePersistedStore();
  const data = reports.underReview.data.Items;
  const total = reports.underReview.data.Total;
  const loading = reports.underReview.loading;
  const userInfoResources = auth.userInfo.Resources;
  const currentBusiness = business.currentBusiness;
  const { token } = currentBusiness;
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const [requestId, setRequestId] = useState();

  const [page, setPage] = useState(1);
  const pageSize = 10;

  const pageChange = (page, pageSize) => {

    setPage(page)
    getUnderReview({
      PageSize: pageSize,
      PageNumber: page
    });

  }
  let searchInput;
  const getColumnSearchProps = (dataIndex, title) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node;
          }}
          placeholder={`جستجو ${title}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            جستجو
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            ریست
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const columns = [
    {
      title: "جزئیات بیمه نامه",
      dataIndex: "operation",
      key: "operation",
      width: 85,
      render: (_, record) =>
        data.length >= 1 && (
          <Space size="middle">
            <Button
              type="link"
              onClick={() => {
                reports.getInsuranceDetailsInfo(record.RequestId)
                setRequestId(record.RequestId);
                general.ToggleInsuranceDetailsModal();
              }} size="small" ><ZoomInOutlined />
            </Button>
          </Space>
        )
    },
    {
      title: "نام بیمه گزار",
      dataIndex: "PersonName",
      key: "PersonName",
      width: 110,
      sorter: (a, b) => {
        let first = "";
        let second = "";
        a.PersonName ? (first = a.PersonName) : (first = "");
        b.PersonName ? (second = b.PersonName) : (second = "");
        return first.localeCompare(second);
      },
      ...getColumnSearchProps("PersonName", "نام بیمه گزار"),
      render: text => <span style={{ color: '#5ec393' }}>{text}</span>,
    },
    {
      title: "نام کاربری",
      dataIndex: "UserName",
      key: "UserName",
      width: 100,
      sorter: (a, b) => {
        let first = "";
        let second = "";
        a.UserName ? (first = a.UserName) : (first = "");
        b.UserName ? (second = b.UserName) : (second = "");
        return first.localeCompare(second);
      },
      ...getColumnSearchProps("UserName", "نام کاربری"),
      render: text => text && strings.getFarsiNum(text),
    },
    {
      title: "وضعیت",
      dataIndex: "RequestStatus",
      key: "RequestStatus",
      width: 100,
    },
    {
      title: "رشته",
      dataIndex: "BranchName",
      key: "BranchName",
      width: 100,
    },
    {
      title: "مبلغ پرداختی",
      dataIndex: "Payment",
      key: "Payment",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "مبلغ کل",
      dataIndex: "SummarizeAmount",
      key: "SummarizeAmount",
      width: 110,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "مابه التفاوت",
      dataIndex: "DebtorAmount",
      key: "DebtorAmount",
      width: 110,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "مدت بیمه نامه",
      dataIndex: "DurationTitle",
      key: "DurationTitle",
      width: 100,
    },
    {
      title: "شرکت بیمه",
      dataIndex: "CompanyName",
      key: "CompanyName",
      width: 100,
    },
    {
      title: "تخفیف",
      dataIndex: "VoucherAmount",
      key: "VoucherAmount",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "جریمه",
      dataIndex: "Penalty",
      key: "Penalty",
      width: 100,
      render: data => data && strings.currencyFormat(data) + ' ریال',
    },
    {
      title: "روش پرداخت",
      dataIndex: "Installment",
      key: "Installment",
      width: 80,
      render: data => data ? 'اقساطی' : 'نقدی'
    },
    {
      title: "کد رهگیری",
      dataIndex: "TrackingCode",
      key: "TrackingCode",
      width: 105,
      sorter: (a, b) => a.TrackingCode.localeCompare(b.TrackingCode),
      ...getColumnSearchProps('TrackingCode', 'کد رهگیری'),
      render: text => text && text.toUpperCase().replace('BM-', '')
    },
    {
      title: "کد درخواست",
      dataIndex: "RequestId",
      key: "RequestId",
      ellipsis: true,
      width: 100,
      ...getColumnSearchProps('RequestId', 'کد درخواست'),
      render: data => data && strings.getFarsiNum(data),
    },
    {
      title: "تاریخ خرید",
      dataIndex: "BuyDate",
      key: "BuyDate",
      width: 110,
      sorter: (a, b) => {
        let first = '';
        let second = '';
        a.BuyDate ? first = a.BuyDate : first = '';
        b.BuyDate ? second = b.BuyDate : second = '';
        return first.localeCompare(second)
      },
      render: data => strings.getFarsiNum(moment(data).format('jYYYY/jMM/jDD'))
    }
  ];

  useEffect(() => {
    if (token)
      getUnderReview({
        PageSize: pageSize,
        PageNumber: page
      }
      );
  }, [token])

  const updateData = () => {
    getUnderReview({
      PageSize: pageSize,
      PageNumber: 1,
    })
    setPage(1);
  };

  return (
    <Card>
      <button type="primary" className="btn btn-primary waves-effect waves-light float-left" htmltype="submit"
        onClick={updateData} style={{ marginBottom: "20px" }}>
        بروزرسانی لیست &nbsp;&nbsp;&nbsp;<i className={loading ? "bx bx-loader bx-spin" : "fas fa-sync-alt"}></i>
      </button>
      <Table
        style={{ overflowX: 'scroll' }}
        className="custom-table"
        size="small"
        bordered
        columns={userInfoResources &&
          (userInfoResources.includes("BusinessSaleReport") ||
            userInfoResources.includes("BusinessSupportReport")) ?
          columns : (columns.filter(col => col.dataIndex !== 'operation'))}
        loading={loading}
        rowKey="RequestId"
        scroll={true}
        dataSource={data}
        pagination={false}
      // rowClassName={(record) => (record.StatusCategoryLatinName === "pending" ? "none" : "highlight")}
      />
      {data && data.length > 0 && <Pagination
        defaultCurrent={1}
        current={page}
        onChange={pageChange}
        pageSize={pageSize}
        total={total}
        showSizeChanger={false} />}
      <InsuranceDetails requestId={requestId} />
    </Card>
  );
}


